import { render, staticRenderFns } from "./DadosPessoais.vue?vue&type=template&id=17fdd842&"
import script from "./DadosPessoais.vue?vue&type=script&lang=js&"
export * from "./DadosPessoais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports